var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_78517",
    "data-name": "Group 78517",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.234,
    height: 25.234,
    viewBox: "0 0 25.234 25.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18139",
    "data-name": "Rectangle 18139",
    width: 25.234,
    height: 25.234,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78516",
    "data-name": "Group 78516",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59264",
    "data-name": "Path 59264",
    d: "M25.234,12.617A12.617,12.617,0,1,1,12.617,0,12.617,12.617,0,0,1,25.234,12.617",
    fill: "#59ad00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59265",
    "data-name": "Path 59265",
    d: "M55.04,53.639a1.927,1.927,0,0,0-2.708.136l-6.083,6.083-2.016-2.016a1.828,1.828,0,1,0-2.572,2.571L44.749,63.5a2.11,2.11,0,0,0,1.431.627h.055c.028,0,.056,0,.084,0a2.109,2.109,0,0,0,1.429-.627L54.9,56.346a1.927,1.927,0,0,0,.136-2.708",
    transform: "translate(-35.531 -46.021)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.7fe628e3519bbc4ae2b17284e6a59e12.svg";
export { ForwardRef as ReactComponent };